module.exports = __webpack_public_path__ + "img/icon_5_28.0b672ccf.png";